module.exports = __webpack_public_path__ + "static/media/location.0c7a65b3.svg";